// extracted by mini-css-extract-plugin
export default {"main":"styles_main__TX5hz","relation_type_label":"styles_relation_type_label__6RSfw"};